import {Component, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from "@angular/router";

@Component({
    selector: 'app-downloads',
    templateUrl: './downloads.component.html',
    styleUrls: ['./downloads.component.scss']
})
export class DownloadsComponent implements OnInit {
    pageTitle: string;
    currentRoute: string = '';
    activeIndex: number | null = null;
    accordionItems = [];

    constructor(private router: Router,
                private route: ActivatedRoute) {
        this.router.events.subscribe(() => {
            this.currentRoute = this.router.url;
        });
        this.route.data.subscribe(data => {
            this.pageTitle = data.title;

        });
    }

    ngOnInit(): void {
        if (this.pageTitle === 'Brochure') {
            this.accordionItems = [
                {
                    title: 'ARNI School of Technology',
                    description: 'Explore engineering and technology programs designed to equip students with practical skills and industry-driven knowledge.',
                    pdfFileName: 'arni-school-of-technology-brochure.pdf'
                },
                {
                    title: 'ARNI School of Business Management & Commerce',
                    description: 'Offers BBA, MBA, and commerce courses focusing on modern business practices, finance, marketing, and entrepreneurship.',
                    pdfFileName: 'arni-school-of-business-management-and-commerce-brochure.pdf'
                },
                {
                    title: 'ARNI School of Art & Humanities',
                    description: 'Provides a deep dive into literature, history, sociology, and philosophy to foster critical thinking and cultural understanding.',
                    pdfFileName: 'arni-schools-of-arts-and-humanities-brochure.pdf'
                },
                {
                    title: 'ARNI School of Basic Sciences & Bio-Technology',
                    description: 'Focuses on core science subjects and biotechnology with modern labs and research opportunities.',
                    pdfFileName: 'arni-school-of-basic-sciences-and-biotechnology-brochure.pdf'
                },
                {
                    title: 'ARNI School of Allied Health Sciences',
                    description: 'Trains students in diagnostic, therapeutic, and support services with hands-on learning in healthcare settings.',
                    pdfFileName: 'arni-school-of-allied-health-sciences-brochure.pdf'
                },
                {
                    title: 'ARNI School of Pharmacy',
                    description: 'Covers pharmaceutical sciences, clinical research, and drug development with practical exposure in labs and hospitals.',
                    pdfFileName: 'arni-school-of-pharmacy-brochure.pdf'
                },
                {
                    title: 'ARNI School of Agriculture',
                    description: 'Offers programs in agricultural sciences, sustainable farming, and agri-business management.',
                    pdfFileName: 'arni-school-of-agriculture-brochure.pdf'
                },
                {
                    title: 'ARNI School of Law',
                    description: 'Prepares future legal professionals with a robust curriculum, moot courts, and case study-based learning.',
                    pdfFileName: 'arni-school-of-law-brochure.pdf'
                },
                {
                    title: 'ARNI School of Hotel Management & Tourism',
                    description: 'Combines theory and practical training in hospitality management, culinary arts, and travel operations.',
                    pdfFileName: 'arni-school-of-hotel-management-and-tourism-brochure.pdf'
                },
                {
                    title: 'ARNI School of Education & Sports',
                    description: 'Offers degrees in education and physical training, focusing on pedagogy, sports science, and leadership in teaching.',
                    pdfFileName: 'arni-school-of-education-and-sports-brochure.pdf'
                },
                {
                    title: 'Vocational Courses',
                    description: 'Provides skill-based programs designed to enhance employability across sectors such as education, healthcare, technology, and physical training, with a strong emphasis on practical learning and industry readiness.',
                    pdfFileName: 'arni-vocational-courses.pdf'
                }
            ];
        } else if (this.pageTitle === 'Registration Form') {
            this.accordionItems = [
                {
                    title: 'Registration Form 2025–26',
                    description: 'Complete the official registration form to enroll for the academic session 2025–26 at Arni University.',
                    pdfFileName: 'arni-registration-form.pdf'
                },
                {
                    title: 'Scholarship Application Form',
                    description: 'Apply for scholarships offered by Arni University for the academic year 2025–26.',
                    pdfFileName: 'arni-scholarship-form.pdf'
                },
                {
                    title: 'Transportation Services Form',
                    description: 'Register for university-provided transportation services for the academic session 2025–26.',
                    pdfFileName: 'arni-transportation-form.pdf'
                },
                {
                    title: 'Download All Forms',
                    description: 'Access and download all necessary application and registration forms for the 2025–26 academic session at Arni University.',
                    pdfFileName: 'arni-all-forms.pdf'
                },
            ];
        } else if (this.pageTitle === 'Migration Policy') {
            this.accordionItems = [
                {
                    title: 'Policy for Migration of Students from the Academic Year 2023-24 onwards',
                    description: 'Official migration policy applicable from the academic year 2023-24. Released on 15 May 2023.'
                },
                {
                    title: 'Migration Policy',
                    description: 'Comprehensive migration policy outlining eligibility and procedures. Issued on 08 Jul 2019.'
                }
            ];
        } else if (this.pageTitle === 'Guidelines') {
            this.accordionItems = [
                {
                    title: 'Academic Policies',
                    description: `
    <ul class="list-disc pl-5 space-y-1">
      <li><span class="font-semibold">Choice-Based Credit System (CBCS):</span> We have a choice-based credit system (CBCS), which was implemented since the 2017-2018 academic session. The motto is to provide a flexible learning system in terms of course selection to promote interdisciplinary learning and skill development.</li>
      <li><span class="font-semibold">Curriculum Design:</span> All the courses are designed as per the UGC & HPU guidelines under the guidance of industry experts, professors, and researchers. We ensure relevant and quality education. </li>
      <li><span class="font-semibold">Examination Protocols:</span> As per the UGC guidelines, we maintain a high level of examination protocols. The university conducts semester-wise examinations for both undergraduate and postgraduate students, adhering to standardized evaluation methods. ​
</li>
    </ul>
  `
                },
                {
                    title: 'Administrative Guidelines',
                    description: '<p><span class="font-semibold">Ordinances:</span> At ARNI University, we are committed to providing the best learning experience to the students and faculty as well. Thus, we have established a set of ordinances covering various aspects of university governance, including faculty educational qualifications, previous records, students\' conduct, and hostel administration.</p>'
                },
                {
                    title: 'Hostel and Residence Policies',
                    description: `
    <ul class="list-disc pl-5 space-y-1">
      <li><span class="font-semibold">Hostel Administration:</span> To avoid any kind of mismanagement, we have separated hostels for boys and girls, that is maintained by different faculty with strict guidelines. Each hostel is managed by designated wardens to ensure a safe and conducive living environment. ​
</li>
      <li><span class="font-semibold">Residency Requirements:</span> While hostel accommodation is encouraged, students may seek permission to reside off-campus under specific circumstances, subject to approval. ​
</li>
    </ul>
  `
                },
                {
                    title: 'Downloads',
                    description: `
    <ul class="list-disc pl-5 space-y-1">
      <li><a href="assets/img/downloads-guidelines/ORDINANCE_(CBCS)_No_14.pdf" class="text-blue-600 underline" target="_blank" rel="noopener">Ordinance No. 14 – Choice-Based Credit System (CBCS)</a></li>
      <li><a href="assets/img/downloads-guidelines/ARNI_UNIVERSITY_Ordinance_1_to_11.pdf" class="text-blue-600 underline" target="_blank"  rel="noopener">Ordinances 1 to 11 – Comprehensive University Policies</a></li>
    </ul>
  `
                }
            ];
        }
    }

    toggleAccordion(index: number): void {
        if (this.activeIndex === index) {
            this.activeIndex = null;
        } else {
            this.activeIndex = index;
        }
    }

    goTo(url: string) {
        this.router.navigateByUrl(url);
    }

}
